/**
 * Who may read the admin agency list.
 *
 * `api/routes/adminRoutes.js` maps the `/agencies` prefix to the `agencies`
 * permission module, so a client that fetches the list without holding
 * `agencies.view` is asking for a 403 it already knows it will get. Measured
 * 2026-09-16 (card 49621): 265 such refusals since 2026-09-03, all from two
 * Customer Support Reps, whose role holds 33 permissions and not this one.
 *
 * The decision takes `hasPermission` as an argument rather than calling
 * `useAuth()` itself, so it stays a pure function and can be graded without a
 * React tree — jest here is `transform: {}` and cannot resolve `.jsx`.
 */
export const AGENCY_VIEW_PERMISSION = 'agencies.view';

/** PURE. True only when this caller may read the admin agency list. */
export const canViewAgencies = (hasPermission) =>
  typeof hasPermission === 'function' && hasPermission(AGENCY_VIEW_PERMISSION) === true;
